exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.__em-attachment-list .mint-cell-title {\r\n    display: flex;\r\n    align-items: center;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5a88c570!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/emapm-form/emapComponents/emAttachmentList.vue
// module id = 170
// module chunks = 0